import script from "./workflowEditor.vue?vue&type=script&lang=js"
export * from "./workflowEditor.vue?vue&type=script&lang=js"

import "./workflowEditor.vue?vue&type=style&index=0&id=c47207a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c47207a2"]])

export default __exports__